module.exports = __webpack_public_path__ + "static/media/21_tn.e7727b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/21_tn.jpg
// module id = 657
// module chunks = 0